// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__bNcES","title":"style_title__eCmMU","mainTitle":"style_mainTitle__1mu7r","subTitle":"style_subTitle__1-d8e"};